import React, { useContext, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import UserContext from "../hooks/UserContext";
import apiFetch from "../utils/apiFetch";
import { getLoginErrorMessage, loginHttpError } from "../utils/loginErrors";
import headerLogo from "../assets/images/header_logo.png";

function getSafeReturnUrl(search) {
  const returnUrl = new URLSearchParams(search).get("returnUrl");

  if (
    !returnUrl ||
    !returnUrl.startsWith("/equipment/") ||
    returnUrl.startsWith("//")
  ) {
    return "/";
  }

  return returnUrl;
}

const Login = () => {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { login: loginUser, checkUser } = useContext(UserContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    setError("");
    if (!login.trim() || !password) {
      setError("Введите логин и пароль.");
      return;
    }
    setIsSubmitting(true);
    let phase = "login";
    let tokenStored = false;

    try {
      const response = await apiFetch("/api/auth/login", {
        method: "POST",
        body: { login, password },
      });

      if (!response.ok) {
        throw loginHttpError(response);
      }

      phase = "response";
      const data = await response.json();
      if (typeof data?.token !== "string" || !data.token.trim() || !data?.user?.id) {
        const error = new Error("Invalid login response");
        error.code = "INVALID_AUTH_RESPONSE";
        throw error;
      }
      phase = "storage";
      localStorage.setItem("token", data.token);
      tokenStored = true;

      phase = "profile";
      const verifiedUser = await checkUser({ requireFresh: true });
      phase = "complete";
      loginUser(verifiedUser);

      navigate(getSafeReturnUrl(location.search), { replace: true });
    } catch (err) {
      if (tokenStored) {
        try { localStorage.removeItem("token"); } catch (_) {}
      }
      setError(getLoginErrorMessage(err, phase));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="nes-login">
      <section className="nes-login__shell" aria-label="NES login">
        <div className="nes-login__brand">
          <div className="nes-login__logo-wrap">
            <img src={headerLogo} alt="NES" className="nes-login__logo" />
          </div>
          <p className="nes-login__eyebrow">NES OPERATIONS</p>
          <h1 className="nes-login__title">Миллий электр тармоқлари</h1>
          <div className="nes-login__grid" aria-hidden="true">
            <span />
            <span />
            <span />
          </div>
        </div>

        <div className="nes-login__panel">
          <div className="nes-login__panel-head">
            <p className="nes-login__kicker">Авторизация</p>
            <h2 className="nes-login__heading">Вход в систему</h2>
          </div>

          <form className="nes-login__form" onSubmit={handleSubmit}>
            <div className="nes-login__field">
              <label htmlFor="login" className="nes-login__label">
                Логин
              </label>
              <input
                type="text"
                id="login"
                className="nes-login__input"
                placeholder="Введите логин"
                value={login}
                onChange={(e) => setLogin(e.target.value)}
                disabled={isSubmitting}
                autoComplete="username"
              />
            </div>

            <div className="nes-login__field">
              <label htmlFor="password" className="nes-login__label">
                Пароль
              </label>
              <input
                type="password"
                id="password"
                className="nes-login__input"
                placeholder="Введите пароль"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={isSubmitting}
                autoComplete="current-password"
              />
            </div>

            {error && (
              <div className="nes-login__error" role="alert">
                {error}
              </div>
            )}

            <button type="submit" className="nes-login__submit" disabled={isSubmitting}>
              {isSubmitting ? "Проверка..." : "Войти"}
            </button>

            <Link to="/turnstile-login" className="nes-login__turnstile">
              Турникет
            </Link>
          </form>
        </div>
      </section>
    </main>
  );
};

export default Login;
